import React from "react";
import Layout from "../../components/Layout";
import HeroSection from "../../components/HeroSection/HeroSection";
import { useTranslation } from "react-i18next";
import ReusableSlider from "../../components/ReusableSlider/ReusableSlider";
import { Helmet } from "react-helmet-async";

/*----- Hero Images -----*/
import heroImage1 from "../../assets/images/crystal-hall/crystalHall8.jpg";
import heroImage2 from "../../assets/images/crystal-hall/crystalHall9.jpg";
import heroImage3 from "../../assets/images/crystal-hall/crystalHall10.jpg";
import heroImage4 from "../../assets/images/crystal-hall/crystalHall11.jpg";
import heroImage5 from "../../assets/images/crystal-hall/crystalHall12.jpg";

/*----- Gallery Images -----*/
import galleryImage1 from "../../assets/images/crystal-hall/crystalHall13.jpg";
import galleryImage2 from "../../assets/images/crystal-hall/crystalHall14.jpg";
import galleryImage3 from "../../assets/images/crystal-hall/crystalHall15.jpg";
import galleryImage4 from "../../assets/images/crystal-hall/crystalHall16.jpg";
import galleryImage5 from "../../assets/images/crystal-hall/crystalHall17.jpg";
import galleryImage6 from "../../assets/images/crystal-hall/crystalHall18.jpg";
import galleryImage7 from "../../assets/images/crystal-hall/crystalHall19.jpg";
import galleryImage8 from "../../assets/images/crystal-hall/crystalHall20.jpg";

const GreatHallGallery = [
  galleryImage1,
  galleryImage2,
  galleryImage3,
  galleryImage4,
  galleryImage5,
  galleryImage6,
  galleryImage7,
  galleryImage8,
];

export default function CrystalHall() {
  const { t } = useTranslation(["crystal_hall", "links"]);
  return (
    <Layout>
      <Helmet>
        <title>Kristalna sala</title>
        <meta
          name="description"
          content={
            "Dobrodošli u prelepu Kristalnu salu za proslave – prostor izuzetne lepote i elegancije, stvoren da zadovolji najsofisticiranije ukuse i pruži nezaboravno iskustvo za vaš poseban događaj"
          }
        />
        <link
          rel="canonical"
          href={"https://vidovdanrestoran.rs/crystal-hall"}
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={"Kristalna sala"} />
        <meta
          property="og:description"
          content={
            "Dobrodošli u prelepu Kristalnu salu za proslave – prostor izuzetne lepote i elegancije, stvoren da zadovolji najsofisticiranije ukuse i pruži nezaboravno iskustvo za vaš poseban događaj"
          }
        />
        <meta property="og:image" content={heroImage3} />
        <meta
          property="og:url"
          content={"https://vidovdanrestoran.rs/crystal-hall"}
        />
        <meta property="og:site_name" content="Vidovdan" />
        <meta property="og:locale" content="sr_RS" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={"Kristalna sala"} />
        <meta
          name="twitter:description"
          content={
            "Dobrodošli u prelepu Kristalnu salu za proslave – prostor izuzetne lepote i elegancije, stvoren da zadovolji najsofisticiranije ukuse i pruži nezaboravno iskustvo za vaš poseban događaj"
          }
        />
        <meta name="twitter:image" content={heroImage3} />
      </Helmet>
      <HeroSection
        images={[heroImage1, heroImage2, heroImage3, heroImage4, heroImage5]}
        title={t("crystal_hall_hero_title")}
        subTitle={t("crystal_hall_hero_subtitle")}
        description={t("crystal_hall_hero_description")}
      />
      <ReusableSlider
        slides={GreatHallGallery}
        title={t("crystal_hall_title")}
        description={t("crystal_hall_description")}
      />
    </Layout>
  );
}
